import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  Transaction,
  Pagination,
  FamilyDetail,
} from "services/reportService";

interface ReportState {
  transactionList: {
    transactions: Transaction[];
    pagination?: Pagination;
  } | null;

  familyDetailList: {
    familydetails: FamilyDetail[];
    pagination?: Pagination;
  } | null;

  successMsg: { message: string; id: string | number };
  errorMsg: { message: string; id: string | number };

  loading: boolean;
  pagination: Pagination | {};
}

const initialState: ReportState = {
  transactionList: null,
  familyDetailList: null,

  successMsg: { message: "", id: "" },
  errorMsg: { message: "", id: "" },

  loading: false,
  pagination: {},
};

const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    fetchTransactions(state, action: PayloadAction<any>) {
      state.transactionList = {
        transactions: action.payload?.transactions || [],
        pagination: action.payload?.pagination || {},
      };
    },

    fetchFamilyDetails(state, action: PayloadAction<any>) {
      state.familyDetailList = {
        familydetails: action.payload?.familydetails || [],
        pagination: action.payload?.pagination || {},
      };
    },

    setPagination(state, action: PayloadAction<Pagination | {}>) {
      state.pagination = action.payload || {};
    },

    reportSuccessMsg(state, action) {
      state.successMsg = action.payload;
    },

    reportErrorMsg(state, action) {
      state.errorMsg = action.payload;
    },

    setReportLoader(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const {
  fetchTransactions,
  fetchFamilyDetails,
  setPagination,
  reportSuccessMsg,
  reportErrorMsg,
  setReportLoader,
} = reportSlice.actions;

export default reportSlice.reducer;


